import './category.component.scss'

const filterElement = document.getElementById('category-filter')
if (filterElement) {
  import(
    /* webpackChunkName: "catalog-filter" */ '../../vue/modules/category-filter.js'
  )
}
